export default __webpack_public_path__ + "static/media/Ies_Toljy.a0e88a5c.png";